import { mergeClassNames } from '@/utils/mergeClassNames';

import styles from './SensorPlacement.module.css';

import { Chest } from './Parts/Chest';
import { LeftArm } from './Parts/LeftArm';
import { LeftCalf } from './Parts/LeftCalf';
import { LeftFoot } from './Parts/LeftFoot';
import { LeftThigh } from './Parts/LeftThigh';
import { PelvisWithLine } from './Parts/PelvisWithLine';
import { PelvisWithoutLine } from './Parts/PelvisWithoutLine';
import { RightArm } from './Parts/RightArm';
import { RightCalf } from './Parts/RightCalf';
import { RightFoot } from './Parts/RightFoot';
import { RightThigh } from './Parts/RightThigh';
import { SensorHighlight } from './SensorHighlight';

export type SensorStatus = 'selected' | 'hidden' | 'not_calibrated' | 'error';

interface SensorPlacementProps {
  isBlurred?: boolean;
  centerPelvis: SensorStatus;
  leftPelvis: SensorStatus;
  rightPelvis: SensorStatus;
  leftThigh: SensorStatus;
  rightThigh: SensorStatus;
  leftCalf: SensorStatus;
  rightCalf: SensorStatus;
  leftFoot: SensorStatus;
  rightFoot: SensorStatus;
}

export const SensorPlacement = ({
  isBlurred,
  centerPelvis,
  leftPelvis,
  rightPelvis,
  leftThigh,
  rightThigh,
  leftCalf,
  rightCalf,
  leftFoot,
  rightFoot,
}: SensorPlacementProps) => {
  return (
    <svg
      className={mergeClassNames(styles.illustration, isBlurred && styles.blurred)}
      fill='none'
      height='487'
      viewBox='0 0 247 487'
      width='247'
      xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_3085_15226)'>
        {centerPelvis === 'hidden' && (
          <>
            <Chest />
            <LeftArm />
            <RightArm />
            <PelvisWithLine />
          </>
        )}
        {centerPelvis !== 'hidden' && <PelvisWithoutLine />}
        <LeftThigh />
        <RightThigh />
        <LeftCalf />
        <RightCalf />
        {leftFoot !== 'hidden' && <LeftFoot />}
        {rightFoot !== 'hidden' && <RightFoot />}
      </g>

      <SensorHighlight status={leftFoot} x={89} y={472} />
      <SensorHighlight status={rightFoot} x={153} y={472} />
      <SensorHighlight status={leftCalf} x={74} y={357} />
      <SensorHighlight status={rightCalf} x={166} y={357} />
      <SensorHighlight status={leftThigh} x={79} y={238} />
      <SensorHighlight status={rightThigh} x={174} y={238} />
      <SensorHighlight status={leftPelvis} x={86} y={104} />
      <SensorHighlight status={rightPelvis} x={167} y={104} />
      <SensorHighlight status={centerPelvis} x={123} y={116} />

      <defs>
        <clipPath id='clip0_3085_15226'>
          <rect fill='white' height='487' transform='translate(0.283203)' width='245.96' />
        </clipPath>
      </defs>
    </svg>
  );
};
